module.exports = __webpack_public_path__ + "static/media/codeexcel.0c21ad95.jpg";